import styled, { css } from 'styled-components';
import { px2rem, getColor } from '../../../stylesheets/tools';
import { fontFamilies } from '../../../stylesheets/settings';

const StyledFilterTag = styled.div`
  .filter-tag {
    position: relative;
    padding: 0px 10px 1px 10px;

    ${props =>
      props.border &&
      css`
        color: #000;
        background-color: transparent;
        background-image: linear-gradient(180deg, currentColor, currentColor),
          linear-gradient(225deg, currentColor, currentColor),
          linear-gradient(0deg, currentColor, currentColor),
          linear-gradient(90deg, currentColor, currentColor),
          linear-gradient(
            135deg,
            transparent 6px,
            currentColor 6px,
            currentColor 8px,
            transparent 8px
          );
        background-position: top right, top right, bottom left, bottom left, top left;
        background-size: calc(100% - 8px) 2px, 2px 100%, 100% 2px, 2px calc(100% - 8px), 10px 10px;
        background-repeat: no-repeat;
      `}

    &:before {
      content: '';
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;

      ${props =>
        props.inverted
          ? css`
              color: #000;
            `
          : css`
              z-index: -1;
              color: #fff;
            `};

      ${props =>
        props.isInvertedArchiveFilter &&
        css`
          color: #f03874;
        `};

      ${props =>
        props.light &&
        css`
          color: ${getColor('gray')};
        `};
      background-color: currentColor;
      position: absolute;

      ${props =>
        props.small && !props.border
          ? css`
              clip-path: polygon(calc(0% + 5px) 0%, 100% 0, 100% 100%, 0 100%, 0% calc(0% + 5px));
            `
          : css`
              clip-path: polygon(calc(0% + 10px) 0%, 100% 0, 100% 100%, 0 100%, 0% calc(0% + 10px));
            `}
    }

    .filter-tag__title {
      display: inline-block;
      text-transform: uppercase;
      font-size: ${px2rem('12px')};
      font-family: ${fontFamilies.default};
      position: relative;
      ${props =>
        props.inverted &&
        css`
          color: #fff;
        `};
    }
  }
`;

export default StyledFilterTag;
